import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: 'always',
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
      cacheTime: 0,
      staleTime: 0,
    },
    mutations: {
      retry: 0,
    },
  },
});